import { render } from "./LanguageMenu.vue?vue&type=template&id=6471b766&scoped=true"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"

import "./LanguageMenu.vue?vue&type=style&index=0&id=6471b766&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6471b766"

export default script